var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.postponesList.length ? _c('div', [_vm._m(0), _c('table', {
    staticClass: "table table-striped mb-0 mt-3"
  }, [_vm._m(1), _c('tbody', _vm._l(_vm.postponesList, function (postpone, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "font-semibold text-black text-nowrap"
    }, [_vm._v(" " + _vm._s(_vm.formatDate(postpone.extra_date)) + " ")]), _c('td', {
      staticClass: "font-semibold text-black"
    }, [_vm._v(" " + _vm._s(_vm.formatHours(postpone.extra_hours)) + " Hours ")]), _c('td', {
      staticClass: "font-semibold text-black"
    }, [(postpone.reason || '').length > 24 ? [_c('span', [_vm._v(" " + _vm._s(_vm.expandedNotes[index] ? postpone.reason : postpone.reason.slice(0, 34) + '...') + " ")]), _c('a', {
      staticClass: "text-primary ml-1",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function click($event) {
          $event.preventDefault();
          return _vm.toggleNotes(index);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.expandedNotes[index] ? 'less' : 'more') + " ")])] : [_vm._v(" " + _vm._s(postpone.reason || '-') + " ")]], 2), _c('td', {
      staticClass: "font-semibold text-black"
    }, _vm._l(postpone === null || postpone === void 0 ? void 0 : postpone.maintenance_attachments, function (file, idx) {
      return _c('b-badge', {
        key: "att-".concat(idx),
        staticClass: "mr-2 cursor-pointer",
        attrs: {
          "variant": "warning",
          "pill": ""
        },
        on: {
          "click": function click($event) {
            return _vm.onPreview(file === null || file === void 0 ? void 0 : file.fileurl);
          }
        }
      }, [_vm._v(" " + _vm._s(file === null || file === void 0 ? void 0 : file.filename) + " "), _c('i', {
        staticClass: "fa fa-download ml-2",
        staticStyle: {
          "font-size": "12px"
        }
      })]);
    }), 1)]);
  }), 0)])]) : _vm._e();

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h4', {
    staticClass: "text-primary my-3"
  }, [_c('strong', [_vm._v("Postpone History")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', {
    staticClass: "thead-light"
  }, [_c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("Postponed Date")]), _c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("Postponed (RH)")]), _c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("Postponed Notes")]), _c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("Attachments")])]);

}]

export { render, staticRenderFns }